<template>
  <div class="content">
    <BlockUI
      v-if="blockScreen"
      :url="blockScreenData.url"
      :message="blockScreenData.msg"
    />

    <ModalDocumento
      :dialog="modalDocumento"
      :user="userSelecionado"
      :showButtons="false"
      @close="modalDocumento = false"
    />

    <ModalNewUser
      :showDialog="modalUser"
      :user="userSelecionado"
      @salvar="save"
      @cancel="modalUser = false"
    />

    <ModalResetPassword
      :showDialog="modalPassword"
      :user="userSelecionado"
      @salvar="resetPassword"
      @cancel="modalPassword = false"
    />

    <ModalCartoesUsuario
      :showModal="modalCard"
      :user="userSelecionado"
      @cancel="modalCard = false"
    />

    <v-card>
      <v-card-title>
        <v-row justify="space-between">
          <span class="title font-weight-medium m-3"> Usuários </span>

          <v-flex xs12 md3 sm3>
            <v-col align="center">
              <v-btn
                block
                color="success"
                class="white--text"
                @click="openModalUser()"
              >
                Novo Usuário
              </v-btn>
            </v-col>
          </v-flex>
        </v-row>
      </v-card-title>

      <v-card-subtitle>
        <v-flex class="mt-2">
          <v-row justify="space-between">
            <v-flex xs12 md4 sm6>
              <v-col align="start">
                <v-select
                  v-model="filters.clientsSelected"
                  :items="clientItems"
                  label="Clientes"
                  color="blue darken-4"
                  item-text="name"
                  item-value="id"
                  multiple
                  placeholder="Selecione os clientes"
                  prepend-icon="mdi-office-building"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0">
                      <span>{{ item.name }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="grey--text text-caption">
                      (+{{ filters.clientsSelected.length - 1 }} outro(s))
                    </span>
                  </template>
                  <v-list-tile
                    slot="prepend-item"
                    ripple
                    @click="toggle"
                    class="v-list-item v-list-item--link theme--light"
                  >
                    <v-list-tile-action>
                      <v-icon
                        :color="
                          this.filters.clientsSelected != null &&
                          this.filters.clientsSelected.length > 0
                            ? 'blue darken-4'
                            : ''
                        "
                        >{{ icon }}</v-icon
                      >
                    </v-list-tile-action>
                    <v-list-tile-title style="margin-left: 35px">
                      Selecionar todos</v-list-tile-title
                    >
                  </v-list-tile>
                  <v-divider slot="prepend-item" class="mt-2" />
                </v-select>
              </v-col>
            </v-flex>
          </v-row>

          <v-row justify="space-between">
            <v-flex xs12 md4 sm6>
              <v-col align="start">
                <v-text-field
                  v-model="filters.name"
                  label="Nome (opcional)"
                  single-line
                  hide-details
                  prepend-icon="mdi-account"
                />
              </v-col>
            </v-flex>

            <v-flex xs12 md4 sm6>
              <v-col align="start">
                <v-text-field
                  v-model="filters.cpf"
                  label="CPF (opcional)"
                  v-mask="'###########'"
                  single-line
                  hide-details
                  prepend-icon="mdi-card-account-details"
                />
              </v-col>
            </v-flex>

            <v-flex xs12 md4 sm6>
              <v-col align="start">
                <v-text-field
                  v-model="filters.email"
                  label="Email (opcional)"
                  single-line
                  hide-details
                  prepend-icon="mdi-email"
                />
              </v-col>
            </v-flex>
          </v-row>

          <v-row>
            <v-flex xs12 md4 sm6>
              <v-col align="start" style="margin-top: 20px;">
                <v-text-field
                  v-model="filters.phone"
                  label="Telefone (opcional)"
                  single-line
                  hide-details
                  prepend-icon="mdi-phone"
                />
              </v-col>
            </v-flex>
            <v-flex xs12 md4 sm6>
              <v-col align="start">
                <v-radio-group label="Status:" v-model="filters.status" row>
                  <v-radio label="Ativos" value="1"></v-radio>
                  <v-radio label="Inativos" value="2"></v-radio>
                </v-radio-group>
              </v-col>
            </v-flex>
            <v-flex xs12 md4 sm6>
              <v-col align="start">
                <v-radio-group label="Aprovado?" v-model="filters.approved" row>
                  <v-radio label="Todos" value="1"></v-radio>
                  <v-radio label="Sim" value="2"></v-radio>
                  <v-radio label="Não" value="3"></v-radio>
                </v-radio-group>
              </v-col>
            </v-flex>
          </v-row>

          <v-row justify="end">
            <v-flex xs12 md3 sm3>
              <v-col align="center">
                <v-btn
                  block
                  class="mt-4 white--text"
                  color="error"
                  @click="limparFiltros()"
                >
                  Limpar filtros
                </v-btn>
              </v-col>
            </v-flex>

            <v-flex xs12 md3 sm3>
              <v-col align="center">
                <v-btn
                  block
                  class="mt-4 white--text"
                  color="primary"
                  @click="filtraUsuarios"
                >
                  Pesquisar
                </v-btn>
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-subtitle>

      <v-divider class="my-0" />

      <v-card-text>
        <v-row justify="end" class="mb-1">
          <v-flex xs12 md3 sm3>
            <v-col align="center">
              <download-excel
                :fetch="getAllUsersToExport"
                :before-generate="startDownload"
                :before-finish="finishDownload"
                :fields="jsonFields"
                name="usuarios.xls"
              >
                <v-btn
                  :disabled="users.length > 0 ? false : true"
                  block
                  color="success"
                  class="white--text"
                >
                  Exportar
                  <v-icon right>mdi-file-excel</v-icon>
                </v-btn>
              </download-excel>
            </v-col>
          </v-flex>
        </v-row>

        <v-data-table
          :headers="headers"
          :items="users"
          :options.sync="pagination"
          :single-expand="true"
          :expanded.sync="expanded"
          item-key="id"
          show-expand
          hide-default-footer
          no-data-text="Sem usuários"
          class="elevation-0 mt-1 mb-3"
        >
          <template v-slot:[`item.name`]="{ item }">
            <td style="text-transform: lowercase">
              {{ item.name }}
            </td>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <ActionButton
              color="info"
              icon="mdi-magnify"
              message="Verificar dados"
              @onclick="openModalDocumento(item)"
            />

            <ActionButton
              message="Cartões"
              icon="mdi-credit-card"
              @onclick="openModalCard(item)"
            />

            <ActionButton
              icon="mdi-pencil"
              message="Editar usuário"
              @onclick="openModalUser(item.id)"
            />

            <ActionButton
              color="warning"
              icon="mdi-key"
              message="Reiniciar senha"
              @onclick="openModalPassword(item)"
            />

            <ActionButton
              color="error"
              icon="mdi-delete"
              message="Excluir usuário"
              @onclick="deleteUser(item.id)"
            />
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" style="background-color: #c1c1c1">
              <v-row justify="space-between">
                <v-flex xs12 md3 sm3>
                  <v-col> Telefone: {{ item.phone }} </v-col>
                </v-flex>

                <v-flex xs12 md2 sm3>
                  <v-col>
                    Status: {{ item.status ? 'Ativo' : 'Inativo' }}
                  </v-col>
                </v-flex>

                <v-flex xs12 md2 sm3>
                  <v-col> Aprovado: {{ item.approved ? 'Sim' : 'Não' }} </v-col>
                </v-flex>

                <v-flex xs12 md5 sm3>
                  <v-col> Cliente: {{ item.clientUser_client_name }} </v-col>
                </v-flex>
                <v-flex xs12 md5 sm3>
                  <v-col> Criação: {{ item.created_at | dateFormat }} </v-col>
                </v-flex>
              </v-row>
            </td>
          </template>
        </v-data-table>

        <v-pagination
          v-model="pagination.page"
          :length="pages"
          @input="next"
          total-visible="10"
        >
        </v-pagination>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { blockScreenUi } from '../../helpers/BlockScreenUi';

import ModalDocumento from '../shared/ModalDocumento.vue';
import ModalNewUser from '../shared/ModalNewUser.vue';
import ModalResetPassword from '../shared/ModalResetPassword.vue';
import ModalCartoesUsuario from '../shared/ModalCartoesUsuario.vue';

import ActionButton from '../shared/ActionButtonsTemplate';

import UserController from '../../controllers/UserController.js';
import ClientController from '../../controllers/ClientController.js';

import { format } from 'date-fns';

import {
  ValidateCPF,
  validateEmail,
  validatePhoneNumber,
} from '../../helpers/Validators';

export default {
  components: {
    ActionButton,
    ModalNewUser,
    ModalDocumento,
    ModalResetPassword,
    ModalCartoesUsuario,
  },
  data() {
    return {
      clientItems: [],
      blockScreen: false,
      blockScreenData: blockScreenUi.blockScreenData,

      userController: new UserController(this.$resource),
      clientController: new ClientController(this.$resource),

      filters: {
        email: '',
        name: '',
        cpf: '',
        clientsSelected: [],
        phone: '',
        status: '1',
        approved: '1',
      },

      users: [],

      jsonFields: {
        Nome: 'name',
        Condominio: 'clientname',
        CPF: 'cpf',
        'E-mail': 'email',
        'Nº Indicações': 'invitationsMade',
        Telefone: 'phone',
        CNH: 'drive_license',
      },
      headers: [
        { text: 'ID', align: 'start', value: 'id' },
        { text: 'Nome', align: 'start', value: 'name' },
        { text: 'CPF', align: 'start', value: 'cpf' },
        { text: 'E-mail', align: 'start', value: 'email' },
        { text: 'Ações', align: 'start', value: 'actions', sortable: false },
      ],

      profile: localStorage.getItem('profile'),
      userSelecionado: {},

      modalUser: false,
      modalCard: false,
      modalDocumento: false,
      modalPassword: false,

      clients: [],
      searchClients: null,
      isLoadingClient: false,

      pages: 1,
      expanded: [],
      pagination: { page: 1 },
    };
  },

  created() {
    this.getUsers();
    this.getClients();
  },

  computed: {
    selecionarTodos() {
      return (
        this.filters.clientsSelected != null &&
        this.clientItems != null &&
        this.filters.clientsSelected.length === this.clientItems.length
      );
    },
    desmarcarSelecao() {
      return (
        this.filters.clientsSelected != null &&
        this.filters.clientsSelected.length > 0 &&
        !this.selecionarTodos
      );
    },
    icon() {
      if (this.selecionarTodos) return 'mdi-close-box';
      if (this.desmarcarSelecao) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },
    computedFields() {
      // Lógica de computação dos campos (fields)
      // ...
    },
  },

  watch: {
    async searchClients() {
      try {
        // Clients have already been loaded or Items have already been requested
        if (this.clients.length > 0 || this.isLoadingClient) {
          return;
        }

        this.isLoadingClient = true;
        this.clients = await this.clientController.getAllClients();
      } catch (error) {
        return this.$awn.alert('Erro ao obter clientes');
      } finally {
        this.isLoadingClient = false;
      }
    },
  },

  methods: {
    async getAllUsersToExport() {
      return this.userController.getAllUsersToExport(this.filters);
    },

    startDownload() {
      this.blockScreen = true;
    },

    finishDownload() {
      this.blockScreen = false;
    },

    filtraUsuarios() {
      this.pages = 1;
      this.pagination = { page: 1 };
      this.users = [];
      this.getUsers();
    },

    async next() {
      this.getUsers();
    },

    async getClients() {
      this.clientController
        .getAllClients()
        .then(res => (this.clientItems = res));
    },
    toggle() {
      this.$nextTick(() => {
        if (this.selecionarTodos) {
          this.filters.clientsSelected = [];
        } else {
          this.filters.clientsSelected = [];
          this.clientItems.map(client => {
            this.filters.clientsSelected.push(client.id);
          });
        }
      });
    },
    async getUsers() {
      this.blockScreen = true;
      try {
        let res = await this.userController.getAllUsers(
          this.pagination.page,
          this.filters
        );

        let numPages = Math.ceil(res.count / 10);
        this.pages = res.data.length > 0 ? numPages : 1;
        this.users = res.data;
      } catch (err) {
        console.error(err);
      } finally {
        this.blockScreen = false;
      }
    },

    limparFiltros() {
      this.filters = {
        email: '',
        name: '',
        cpf: '',
        clientsSelected: [],
        phone: '',
        status: '1',
        approved: '1',
      };
      this.filtraUsuarios();
    },

    async openModalDocumento(item) {
      try {
        let cnh = await this.userController.getCnhByUser(item.id);
        item.cnh_uri = cnh ? cnh.cnh_uri : null;
        let selfie = await this.userController.getSelfieByUser(item.id);
        item.selfie_uri = selfie ? selfie.selfie_uri : null;

        this.userSelecionado = item;
        this.modalDocumento = true;
      } catch (error) {
        this.$awn.alert(error.message);
        console.log(error);
      }
    },

    async openModalUser(userId) {
      if (userId) {
        this.userSelecionado = await this.userController.getUserDetail(userId);
      } else {
        this.userSelecionado = {};
      }
      this.modalUser = true;
    },

    async openModalCard(user) {
      this.userSelecionado = user;
      this.modalCard = true;
    },

    async openModalPassword(value) {
      this.userSelecionado = value;
      this.modalPassword = true;
    },

    deleteUser(userId) {
      swal({
        title: 'Você tem certeza?',
        text: 'Essa ação não poderá ser desfeita!',
        icon: 'error',
        buttons: true,
        dangerMode: true,
      }).then(willDelete => {
        if (willDelete) {
          this.userController.delete(userId).then(
            res => {
              this.getUsers();
              this.$awn.success(res.message);
            },
            error => {
              this.$awn.alert(error.message);
            }
          );
        }
      });
    },

    async resetPassword(value) {
      if (value.password !== value.confirmPassword) {
        return this.$awn.alert('As senhas digitadas não coincidem.');
      }
      let response = null;
      try {
        response = await this.userController.resetPassword(
          this.userSelecionado.id,
          value.password,
          value.hasForPasswordChange
        );
      } catch (error) {
        console.log(error);
        return this.$awn.alert('Ocorreu algum erro.');
      }
      if (response.OK) {
        this.modalPassword = false;
        this.$awn.success(response.message);
      } else {
        this.$awn.warning(response.message);
      }
    },

    async save() {
      if (!ValidateCPF(this.userSelecionado.cpf.replace(/\.|\-/gi, ''))) {
        return this.$awn.alert('Seu CPF está inválido!');
      }

      if (!validateEmail(this.userSelecionado.email)) {
        return this.$awn.alert('Email inválido!');
      }

      if (!validatePhoneNumber(this.userSelecionado.phone)) {
        return this.$awn.alert('Insira um número de celular válido!');
      }

      this.blockScreen = true;

      try {
        let response = this.userSelecionado.id
          ? await this.userController.update(this.userSelecionado)
          : await this.userController.createByAdm({
              cpf: this.userSelecionado.cpf,
              drive_license: this.userSelecionado.drive_license,
              email: this.userSelecionado.email,
              hasForPasswordChange: true,
              name: this.userSelecionado.name,
              password: this.userSelecionado.password,
              client_id: this.userSelecionado.client_id,
              profile_id: this.userSelecionado.profile_id,
              gender: this.userSelecionado.gender,
              phone: this.userSelecionado.phone,
              approved: true,
            });
        if (response.ok) {
          this.userSelecionado.id
            ? this.$awn.success('Usuário editado com sucesso!')
            : this.$awn.success('Usuário cadastrado com sucesso!');

          this.modalUser = false;
          this.userSelecionado = {};
          await this.getUsers();
        } else {
          this.$awn.warning(response.message);
        }
      } catch (error) {
        console.log(error);
        this.$awn.alert(error);
      }
      this.blockScreen = false;
    },
  },

  filters: {
    dateFormat(date) {
      const formattedDate = format(new Date(date), 'DD/MM/YYYY HH:mm:ss');
      return formattedDate;
    }
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.radios {
  margin: 5px;
}
.radios input {
  margin-right: 3px;
}
.radios label {
  margin-right: 15px;
}
.table-custom-vue {
  margin: 20px;
}
.table-custom-vue td:last-child {
  display: flex;
  justify-content: center;
}
.table-custom-vue thead tr > th,
.table-custom-vue tbody td {
  text-align: center !important;
}
.filters {
  max-width: 100% !important;
}

.import-driver-button,
.new-driver-button {
  border: none;
  &:hover {
    background: var(--primary-color-hover);
  }
}
.card-header .filter-header {
  background: var(--secondary-color) !important;
}

.import-driver-button,
.new-driver-button {
  border: none;
  &:hover {
    color: white;
    background: var(--primary-color-hover);
  }
}
.colorApp {
  background-color: var(--secondary-color) !important;
}
.card-filter {
  border: 1px solid var(--secondary-color) !important;
  margin-bottom: 15px;
}
</style>
